/* eslint-disable no-console */
import axios from 'axios';
import { fetchWithCancellableToken } from './fetchWithCancellableToken';

export type NormatimResponse = {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  display_name: string;
  address: {
    county: string;
    state: string;
    'ISO3166-2-lvl4': string;
    country: string;
    country_code: string;
  };
  boundingbox: number[];
};
export const fetchNormatimLocation = async ({
  lat,
  lon,
  zoom = 8
}: {
  lat: number;
  lon: number;
  zoom?: number;
}): Promise<NormatimResponse | Error> => {
  // do fetch
  const source = axios.CancelToken.source();

  // Simulate an async operation that can be canceled
  const fetchPromise = fetchWithCancellableToken(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=${zoom}&accept-language=en`,
    source
  );

  try {
    const data = await fetchPromise;
    if ('error' in data) {
      throw new Error(data.error);
    }
    return data;
  } catch (error) {
    return error as Error;
  }
};
